import { createAsyncThunk } from "@reduxjs/toolkit";
import { TServiceError } from "types/general";
import { toastMessage } from "components/ToastMessage";
import {
  IAssetDashboardSummary,
  getAssetDashboardSummary,
} from "api/getAssetDashboardSummary";
import {
  IAssetDashboardCompetitiveSetItem,
  getAssetDashboardCompetitiveSet,
} from "api/getAssetDashboardCompetitiveSet";
import { ASSET_DASHBOARD_SLICE_NAME } from "./constants";

// TODO: move getAssetDashboardSummary logic to the API layer

export const fetchAssetDashboardSummary = createAsyncThunk<
  IAssetDashboardSummary,
  string,
  { rejectValue: TServiceError }
>(
  `${ASSET_DASHBOARD_SLICE_NAME}/fetchAssetDashboardSummary`,
  async (propertyId, { rejectWithValue }) => {
    try {
      return await getAssetDashboardSummary(propertyId);
    } catch (err) {
      toastMessage({
        message: "Failed to load the summary. Please try again.",
        type: "error",
        position: "top-right",
      });

      return rejectWithValue({
        code: err.code,
        message: err.response?.data ?? err.message,
      });
    }
  }
);

export const fetchAssetDashboardCompetitiveSet = createAsyncThunk<
  IAssetDashboardCompetitiveSetItem[],
  string,
  { rejectValue: TServiceError }
>(
  `${ASSET_DASHBOARD_SLICE_NAME}/fetchAssetDashboardCompetitiveSet`,
  async (propertyId, { rejectWithValue }) => {
    try {
      return await getAssetDashboardCompetitiveSet(propertyId);
    } catch (err) {
      toastMessage({
        message: "Failed to load the competitive set. Please try again.",
        type: "error",
        position: "top-right",
      });

      return rejectWithValue({
        code: err.code,
        message: err.response?.data ?? err.message,
      });
    }
  }
);
